import {
	changePage,
	downloadClaims,
	setclaimUuids,
} from 'feature/claims/claimsSlice';
import useDevice from 'hooks/DesktopDevice.hook';
import { FC, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'store/store';
import Button from 'styles/button/Button';
import Pagination from 'styles/pagination/Pagination';
import Stack from 'styles/stack/Stack';
import { SubCollections } from 'types/Form';
import { useTranslation } from 'utils/translations';

const ClaimListFooter: FC<{}> = () => {
	const dispatch = useDispatch<AppDispatch>();
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: 'clientLabels',
	});
	const { isDesktop } = useDevice();
	const { claimUuids, pages, page, claims, downloadAll, claimExcludeUuids } =
		useSelector((store: RootState) => store.claims);

	const { subcollection } = useSelector((store: RootState) => store.form);
	const isNotifications = subcollection === SubCollections.NOTIFICATION;

	const refreshClaimIdsList = useMemo(
		() =>
			!claims.some(claim => claimExcludeUuids.includes(claim.claimUUID)) &&
			downloadAll,
		[claimExcludeUuids, claims, downloadAll],
	);

	const handleChangePage = (
		event: React.ChangeEvent<unknown>,
		value: number,
	) => {
		event.preventDefault();
		dispatch(changePage(value));
	};

	const handleClick = (type: string) => {
		dispatch(downloadClaims({ Uuid: undefined, type: type }));
	};

	useEffect(() => {
		if (refreshClaimIdsList)
			dispatch(setclaimUuids(claims.map(e => e.claimUUID)));
	}, [claims, dispatch, refreshClaimIdsList]);

	return (
		<Stack
			direction={'row'}
			position={'relative'}
			sx={{ my: !!isDesktop ? 5.5 : 2 }}
			alignItems={'center'}
			justifyContent={'space-between'}
		>
			<Stack
				minHeight="24px"
				direction={'row'}
				flexGrow={1}
				sx={{
					justifyContent: !!isDesktop ? 'center' : 'flex-start',
					alignItems: 'center',
				}}
			>
				{pages > 1 ? (
					<Pagination page={page} count={pages} onChange={handleChangePage} />
				) : null}
			</Stack>
			<Stack
				direction={'row'}
				position={'absolute'}
				right={0}
				sx={{
					gap: 2,
					alignContent: 'center',
					justifyContent: 'flex-end',
					display: isNotifications ? 'none' : 'flex',
				}}
			>
				<Button
					type="button"
					variant="contained"
					disabled={claimUuids.length > 0 ? false : true}
					fullWidth={false}
					onClick={() => handleClick('XLSX')}
				>
					{tClientLabels('view-claims.exportButton.XLSX')}
				</Button>
				<Button
					type="button"
					variant="contained"
					disabled={claimUuids.length > 0 ? false : true}
					fullWidth={false}
					onClick={() => handleClick('PDF')}
				>
					{tClientLabels('view-claims.exportButton.PDF')}
				</Button>
			</Stack>
		</Stack>
	);
};

export default ClaimListFooter;
